import React, { useEffect, useState, useRef } from 'react';
import Accordions from '../../Components/Accordion/AccordionRatingView'
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import API from '../../Api/Api';
import { getStarColorClass } from '../../Functions/RatingLabelColor';
import { IMAGE_PATHS, DOMAIN_URL, base64Encode, base64Decode,formatExperienceDate,getPerformanceRating } from '../../Functions/Constant';
import Spinner from 'react-bootstrap/Spinner';
import InfoTooltip from '../../Components/InfoTooltip'
import StarRating from '../../Components/StarRating'
import TextWithReadMore from '../../Components/Readmore'
import ShareLinkModal from "../../Components/ShareLinkModal";
import ConfirmationPopup from '../../Components/ConfirmationPopup'
import ConfirmPopupShareLink from '../../Components/ConfirmPopupShareLink'
import InfoTooltipRating from '../../Components/InfoTooltipRating'


const ProfessionalSummary = ({ scrollToReviews, professional, ratingsPorfin, experienceRef ,userData,user_id,showBuyAlert}) => {
console.log("user_id",user_id)
    const [show, setShow] = useState(false);
    const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(false);
    const [loading, setLoading] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [experiences, setExperiences] = useState([]);
    const [query, setQuery] = useState("");
    const [locationquery, setLocationquery] = useState("");
    const [locationsuggestions, setLocationSuggestions] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [showPopupC, setShowPopupC] = useState(false);
    const [selectedValue, setSelectedValue] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const formikRef = useRef(null);
    const [showFullq, setShowFullq] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [popupData, setPopupData] = useState({
        isOpen: false,
        title: "",
        message: "",
        onClose: () => { },
        onConfirm: () => { },
        linkToCopy: ""
    });

    const [experience, setExperience] = useState({
        title: "",
        employmentType: "",
        company: "",
        startMonth: "",
        startYear: "",
        endMonth: "",
        endYear: "",
        isCurrentlyWorking: false,
        location: "",
        locationType: "",
        jobDescription: "",
        profileHeadline: "",
        startSalary: "",
        lastSalary: "",
        experience_id: "",
        otherCompany: ""
    });

    // Open & Close Modal
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

   

    const fetchCompanies = async (search) => {
        if (!search) {
            setSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await API.get(`/autocomplete/company?query=${search}`);
            // Debugging: Check API response

            // Extract the array properly from response
            const companyList = Array.isArray(response) ? response : [];

           // Debugging: Check extracted list

            setSuggestions(companyList); // Update state with extracted list
        } catch (error) {
            console.error("Error fetching companies:", error);
            setSuggestions([]);
        } finally {
            setLoading(false);
        }
    };
    const fetchLocation = async (search) => {
        if (!search) {
            setLocationSuggestions([]);
            return;
        }
        setLoading(true);
        try {
            const response = await API.get(`/autocomplete/locations?query=${search}`);
            console.log("Raw API Response:", response); // Debugging: Check API response

            // Extract the array properly from response
            const locationList = Array.isArray(response) ? response : [];
 // Debugging: Check extracted list

            setLocationSuggestions(locationList); // Update state with extracted list
        } catch (error) {
            console.error("Error fetching locationList:", error);
            setLocationSuggestions([]);
        } finally {
            setLoading(false);
        }
    };

    

    const fetchExperience = async () => {
        const response = await API.get(`/experiences?user_id=${user_id}`);
        setExperiences(response.experiences);
        console.log(response);
    };
    useEffect(() => {
        if(!showBuyAlert){
            fetchExperience();
        }
        
    }, [userData]);
  
    const [visibleSkills, setVisibleSkills] = useState(10);
    const loadMoreSkills = () => {
        setVisibleSkills((prev) => prev + 10);
    };


    const handleCloseWithConfirmation = (values) => {


        const currentValues = formikRef.current?.values || {};
        const isFormFilled = Object.values(currentValues).some(val => val && val !== "");
        if (!isEditMode && isFormFilled) {
            setShowPopupC(true); // Show confirmation popup
        } else {
            handleClose();
            setTimeout(() => {
                formikRef.current?.resetForm(); // Reset form fields
            }, 100);
        }
    };
    const handleCreateLink = () => {
        setShowModal(true);
    };

    return (
        <>
            {
                ratingsPorfin?.total_reviews > 0 && !showBuyAlert ? (<section className=" pt-[40px] pb-[20px] px-4 ">
                    <Container>
                        <Row>
                            <Col xs={12} md={12}>
                                <div className="flex justify-between items-baseline">
                                    <div>
                                        <h3 className="text-[28px] font-bold text-black  mb-1 leading-[1.5]">Professional Reviews</h3>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="rounded-lg p-6 pt-0 border-1 bg-1 custm-bg shdo-box" >
                            <h3 className="text-[24px] font-bold mb-0 text-[#000]">Summary</h3>
                            <hr className="border-gray-300 mb-4 border-t-1" />
                            <Col lg={6} md={12} className="mb-6">
                                <div className="flex items-start space-x-3 mb-3">
                                    <div className="mt-[8px]">
                                        <span className="text-[40px] font-bold text-gray-900 lt">{ratingsPorfin.overall_rating.toFixed(1) ?? "0.0"}</span>
                                    </div>
                                    <div className="leading-[1.4]">
                                        <InfoTooltipRating className="text-[16px] font-bold text-gray-900" rating={ratingsPorfin?.overall_rating} />
                                        <div className="flex items-center  mb-2">
                                        
                                            <StarRating rating={ratingsPorfin?.overall_rating} starSize={15} />
                                            <span className="text-gray-600 text-[14px] ml-2 cursor-pointer hover:underline hover:text-black transition" onClick={scrollToReviews}>
                                                {ratingsPorfin?.total_reviews ?? 0} Reviews
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="bg-[#74787F] text-white text-[14px] px-3 py-0 rounded-[0.6rem] inline-block shdo-box sm:leading-[1.5]">
                                    This summary is created by AI, based on recent reviews.
                                </div>
                                <p className="text-gray-700 text-[14px] mt-3 leading-[1.5]">
                                    <TextWithReadMore text={professional?.ai_summary} />
                                </p>

                                {professional.key_strengths != null && Array.isArray(professional.key_strengths) && professional.key_strengths.length > 0 ? (
                                    <div className="mt-2">
                                        <h4 className="font-bold text-gray-900 text-[16px] mb-2">Key Strengths</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {
                                                professional.key_strengths.map((skill, index) => (
                                                    <span key={index} className="flex items-center px-2 py-0 text-sm font-medium text-black rounded-full gap-2 h-m bg-white">
                                                        <i className={`fas fa-star ${getStarColorClass(skill.rating)}`}></i>
                                                        <span className="black-class"> {skill.name} </span>
                                                        <span className="text-gray-500"> ({skill.total})</span>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                                {/* Improvement Areas */}
                                {professional.improvement_areas != null && Array.isArray(professional.improvement_areas) && professional.improvement_areas.length > 0 ? (
                                    <div className="mt-2">
                                        <h4 className="font-bold text-gray-900 text-[16px] mb-2">Improvement Areas</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {
                                                professional.improvement_areas.map((weakness, index) => (
                                                    <span key={index} className="flex items-center px-2 py-0 font-medium text-black text-sm rounded-full gap-2 h-m bg-white">
                                                        <i className={`fas fa-star ${getStarColorClass(weakness.rating)}`}></i>
                                                        <span className="black-class"> {weakness.name} </span>
                                                        <span className="text-gray-500"> ({weakness.total})</span>
                                                    </span>
                                                ))
                                            }
                                        </div>
                                    </div>
                                ) : (
                                    <></>
                                )}
                            </Col>

                            <Col lg={6} md={12} className="">
                                <Accordions

                                    data={Array.isArray(professional?.category_ratings) ? professional.category_ratings : []}
                                />
                            </Col>
                        </Row>
                    </Container>
                </section>) : (
                    <></>
                )
            }
            {
                !showBuyAlert && (<section className="pb-[15px] px-4 " ref={experienceRef}>
                    <Container>
                        {/* Experience Header */}
                        <Row>
                            <Col xs={12} md={12} className={`${experiences.length === 0 ? "p-0" : ""}`}>
                                <div className={`flex justify-between items-baseline  ${experiences.length === 0 ? "bg-white rounded-lg p-6 border border-gray-200  shadow-lg" : ""}`}>
                                    <div>
                                        <h3 className={`text-[22px] font-bold text-gray-900 mb-2 leading-[1.4] ${experiences.length === 0 ? "mt-1" : "mt-3"}`}>Experience <InfoTooltip text="Add work experience to get feedback from colleagues and managers." /></h3>
                                    </div>
                                    {/* <div className="cl-plu">
                                        <i className="fas fa-plus black-class font-thin text-[27px] cursor-pointer i-p" onClick={addExperience}></i>
                                    </div> */}
                                </div>
                            </Col>
                        </Row>
                        {
                            experiences.map((experience, index) => (
                                <Row className="bg-white rounded-lg p-6 border-1 mb-4 !pr-[14px]">
                                    <Col lg={1} md={2} sm={2} xs={2}>
                                        <img
                                            src={IMAGE_PATHS.BUILDING}
                                            className="w-[60px] h-[60px] bg-gray-300 rounded-md sm:w-[auto] sm:h-[auto]"
                                        />
                                    </Col>
                                    <Col lg={10} md={9} sm={9} xs={8} className="leading-[1.4]">
                                        <h4 className="text-lg font-bold text-gray-900 mb-0">{experience.title}</h4>
                                        <p className="text-gray-700 overflow-hidden ">
                                            <span className='font-bold text-gray-600 '> {experience.company_name.length > 50 ? `${experience.company_name.substring(0, 50)}... ` : experience.company_name}
                                            </span><span className="ml-1 font-bold text-gray-600 ">| {experience.employment_type}</span></p>
    
                                        <p className="text-gray-700">
                                            {formatExperienceDate(experience.start_month, experience.start_year, experience.end_month, experience.end_year)}
                                        </p>
                                        <p className="text-gray-700">{experience.location}</p>
                                        <p className="text-gray-700 mt-2">
                                             <TextWithReadMore text={experience.description} />
                                        </p>
                                    </Col>
                             
    
                                    {
                                        experience.overall_rating != null && experience.overall_rating.total_reviews > 0 ? (<>
                                            <hr className="border-gray-300 my-4 border-t-1" />
                                            <Col lg={2} md={12} className="text-start">
                                                <div className="text-[40px] font-bold text-gray-900 mb-0 leading-[1] lt">{experience.overall_rating.overall_rating}</div>
                                                <InfoTooltipRating className="font-medium text-[18px] text-[#000]" rating={experience.overall_rating.overall_rating} />
                                                <div className="flex  mt-0">
    
                                                    <StarRating rating={experience.overall_rating.overall_rating} starSize={15} />
                                                </div>
                                                <p className="text-gray-500 text-sm cursor-pointer hover:underline hover:text-black transition" onClick={scrollToReviews}>{experience.overall_rating.total_reviews} Reviews</p>
                                            </Col>
    
                                            {/* Rating Breakdown */}
                                            <Col lg={4} md={12} sm={12} className="border-r border-gray-300 sm:border-r-0 md:border-r-0">
                                                <div className="space-y-1">
                                                    {[
                                                        { label: 5, value: parseInt(experience.overall_rating.excellent) },
                                                        { label: 4, value: parseInt(experience.overall_rating.very_good) },
                                                        { label: 3, value: parseInt(experience.overall_rating.average) },
                                                        { label: 2, value: parseInt(experience.overall_rating.poor) },
                                                        { label: 1, value: parseInt(experience.overall_rating.terrible) },
                                                    ].map((item, index) => (
                                                        <div key={index} className="flex items-center justify-between space-x-2">
                                                          
                                                            <span className="text-gray-900 text-sm font-medium w-[80px]" >{getPerformanceRating(item.label).level}</span>
    
                                                            {/* Progress Bar */}
                                                            <div className="flex-1 h-[12px] bg-gray-200 rounded-full overflow-hidden mx-2">
                                                                <div
                                                                    className="h-full yellow-b rounded-full"
                                                                    style={{
                                                                        width: `${experience.overall_rating.total_reviews > 0
                                                                            ? (item.value / experience.overall_rating.total_reviews) * 100
                                                                            : 0
                                                                            }%`,
                                                                    }}
                                                                ></div>
                                                            </div>
    
                                                            {/* Count */}
                                                            <span className="text-gray-900 text-sm font-medium sm:w-[18px] w-[40px] text-start pl-[8px]">
                                                                {item.value}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
                                            <Col lg={6} md={12} sm={12} className="pl-[45px] rpl sm:pt-[20px] md:pt-[20px] md:pl-[17px]">
                                                <div className="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-1 gap-y-2 gap-x-4">
                                                    {experience.categories.map((item, index) => (
                                                        <div key={index} className="flex flex-col justify-center items-start leading-[1]">
                                                            <div className="leading-[1.4] flex items-center h-[20px]">
                                                                <span className="font-medium text-[14px] text-[#000]">{item.name}</span>
                                                            </div>
                                                            <div className="flex items-center w-full">
                                                                <div className="w-[78%] h-[12px] bg-gray-200 rounded-full overflow-hidden mr-2 sm:w-[94%] xs:w-[92%] md:w-[92%]">
                                                                    <div className="h-full yellow-b" style={{ width: `${(item.avg_rating / 5) * 100}%` }}></div>
                                                                </div>
                                                                <div className="dd">
                                                                    <span className="text-[#000] text-[14px] ">{item.avg_rating.toFixed(1)}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </Col>
    
    
                                            {/* Tags Section */}
                                            <Row className="mt-4">
                                                <Col lg={12}>
                                                    <div className="flex flex-wrap gap-2 mt-2">
                                                        {
                                                            experience.skills.slice(0, visibleSkills).map((skill, index) => {
                                                                let starColor = getStarColorClass(skill.avg_rating);
                                                                return (
                                                                    <span
                                                                        key={index}
                                                                        className="flex items-center px-2 py-0 text-sm font-medium text-black rounded-full gap-2 h-m bg-white"
                                                                    >
                                                                        <i className={`fas fa-star mr-1 ${starColor}`}></i>
                                                                        <span className="black-class">{skill.name}</span>
                                                                        <span className="text-gray-500"> ({skill.total_ratings})</span>
                                                                    </span>
                                                                );
                                                            })
                                                        }
                                                        {
                                                            experience.skills.length > 10 && (
                                                                <button
                                                                    onClick={() => {
                                                                        if (visibleSkills < experience.skills.length) {
                                                                            setVisibleSkills((prev) => prev + 10); // View More
                                                                        } else {
                                                                            setVisibleSkills(10); // View Less
                                                                        }
                                                                    }}
                                                                    className="text-black font-medium ml-2 cursor-pointer hover:underline"
                                                                >
                                                                    {visibleSkills < experience.skills.length ? "View More" : "View Less"}
                                                                </button>
                                                            )
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
    
                                          
                                        </>) : (<>
                                           
                                        </>)
                                    }
    
                                </Row>
                            ))
                        }
                    </Container>
                </section>)
            }
            


          

       
        </>
    );
};

export default ProfessionalSummary;
